import {z} from "zod";

import {VEHICLE_CHECK_OUTCOMES} from "../lib/constants";

const plateSchema = z
  .string()
  .trim()
  .min(2, "Plate is required")
  .max(12, "Plate is too long")
  .transform((value) => value.toUpperCase());

const stateSchema = z
  .string()
  .trim()
  .length(2, "State is required")
  .transform((value) => value.toUpperCase());

export const vehicleCheckLookupSchema = z.object({
  plate: plateSchema,
  state: stateSchema,
});

export type VehicleCheckLookupFormValues = z.input<typeof vehicleCheckLookupSchema>;

export const vehicleCheckConfirmSchema = z
  .object({
    plate: plateSchema,
    state: stateSchema,
    outcome: z.enum(VEHICLE_CHECK_OUTCOMES as [string, ...string[]]),
    vehicle_id: z.number().int().positive().nullable(),
    citation_id: z.number().int().positive().nullable(),
    stored_vehicle_id: z.number().int().positive().nullable(),
    notes: z.string().trim().max(2000).optional().or(z.literal("")),
  })
  .superRefine((values, ctx) => {
    if (values.outcome !== "unknown_vehicle" && !values.vehicle_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["vehicle_id"],
        message: "Select the matched vehicle or choose Unknown vehicle.",
      });
    }

    if (values.outcome === "citation_issued" && !values.citation_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["citation_id"],
        message: "Link a citation for this outcome.",
      });
    }

    if (values.outcome === "stored_tracking" && !values.stored_vehicle_id) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["stored_vehicle_id"],
        message: "Link a stored vehicle record for this outcome.",
      });
    }
  });

export type VehicleCheckConfirmFormValues = z.input<typeof vehicleCheckConfirmSchema>;
